export const recentPurchases = [
  { name: 'Jennifer W.', city: 'Denver', country: 'United States', time: '2 minutes ago' },
  { name: 'Lucía M.', city: 'Madrid', country: 'Spain', time: '5 minutes ago' },
  { name: 'Thomas B.', city: 'Hamburg', country: 'Germany', time: '8 minutes ago' },
  { name: 'Valentina R.', city: 'Córdoba', country: 'Argentina', time: '11 minutes ago' },
  { name: 'Sarah O.', city: 'Brisbane', country: 'Australia', time: '14 minutes ago' },
  { name: 'Carlos E.', city: 'Guadalajara', country: 'Mexico', time: '17 minutes ago' },
  { name: 'Émilie T.', city: 'Quebec City', country: 'Canada', time: '21 minutes ago' },
  { name: 'Priya S.', city: 'London', country: 'United Kingdom', time: '25 minutes ago' },
  { name: 'Diego F.', city: 'Bogotá', country: 'Colombia', time: '29 minutes ago' },
]
